if (!customElements.get('products-spotlight')) {
	class ProductsSpotlight extends HTMLElement {
		constructor() {
			super();
            this.spotlights = [];
            this.productEls = [];
		}
		connectedCallback() {
            this.spotlights = this.querySelectorAll('[data-hotspot-id]');
            this.productEls = this.querySelectorAll('[data-hotspot-product]');

            if (this.spotlights && this.productEls) {
                this.initListeners();
            }
		}
        initListeners() {
            this.spotlights.forEach(spotlight => {
                spotlight.addEventListener('click', (e) => {
                    this.onClick(spotlight);
                });
            })
        }
        onClick(spotlight) {
            const spotlightId = spotlight.dataset.hotspotId ?? undefined;

            if (spotlightId) {
                const matchingProduct = this.querySelector([`[data-hotspot-product="${spotlightId}"]`]) ?? "";

                if (matchingProduct) {
                    this.spotlights.forEach(el => el.classList.remove('active'));
                    spotlight.classList.add('active');

                    this.productEls.forEach(el => el.classList.add('hidden'));
                    matchingProduct.classList.remove('hidden');
                }
            }
        }
	}
	customElements.define('products-spotlight', ProductsSpotlight);
}
